import { MONITORING_GRAPHICS, SERVER_MANAGEMENT } from '../../constants/routes.constants';
import { getSearchParameter } from '../../utils/urlFunctions';

const MONITORING_PREFIX = '/monitoring';

const persistentRoutes = [SERVER_MANAGEMENT, MONITORING_GRAPHICS];
const persistentTabs = ['server-management', 'graphics'];

export const switchMonitoringTab = (tab, history) => {
  if (history.location.pathname.includes(`${MONITORING_PREFIX}/${tab}`)) return;

  const keepDateParams = persistentRoutes.includes(history.location.pathname) && persistentTabs.includes(tab);
  const transferableParams = keepDateParams
    ? ['restaurantUuid', 'timeInterval', 'startDate', 'endDate', 'interval']
    : ['restaurantUuid'];

  const searchParams = transferableParams.reduce((acc, param) => {
    const paramValue = getSearchParameter(param);

    if (paramValue) {
      const divider = acc !== '' ? '&' : '?';
      let fullSearchParam = `${param}=${paramValue}`;

      if (param === 'restaurantUuid' && tab === 'graphics') {
        return acc;
      }

      return acc + divider + fullSearchParam;
    }

    return acc;
  }, '');

  history.push(`${MONITORING_PREFIX}/${tab}` + searchParams);
};

export const formatLabels = (labels = {}) =>
  Object.keys(labels)
    .map((key) => ({ label: key, value: labels[key] }))
    .sort((a, b) => a.label.localeCompare(b.label));

export function isJetson(machine) {
  return String(machine).toLowerCase().includes('jetson');
}
